import React from 'react';
import CartProduct from './CartProduct';
import CartGISData from './CartGISData';
import { Redirect } from 'react-router';


class Cart extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
            redirect: false
        };
    }

    componentDidMount() {
        window.addEventListener('keydown', this.keyDown);
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.keyDown);
    }

    keyDown = (e) => {
        if (e.key === "Escape") {
            this.closeFloatCart()
        }
    }

    openFloatCart = () => {
        this.setState({ isOpen: true });
    };

    closeFloatCart = () => {
        this.setState({ isOpen: false });
    };

    proceedToCheckout = () => {
        this.setState({ redirect: true });
    };

    render() {
        //console.log(this.props);
        const products = this.props.cartItems.map((product, index) => {
            return (
                <CartProduct key={index} product={product} removeCartItem={(product) => this.props.removeCartItem(product)} />
            );
        });

        const gisData = this.props.cartGISData.map((product, index) => {
            return (
                <CartGISData key={index} product={product} removeCartGISData={(product) => this.props.removeCartGISData(product)} />
            );
        });

        const stpData = this.props.cartSTPData.map((product, index) => {
            product.name = product.assetNumber
            return (
                <CartGISData key={product.assetNumber} product={product} removeCartGISData={product => this.props.removeCartSTPData(product)} />
            )
        })

        const priceTotal = (this.props.cartItems.reduce((totalPrice, item) => totalPrice + item.Price, 0) +
            this.props.cartGISData.reduce((totalPrice, item) => totalPrice + item.price, 0) +
            this.props.cartSTPData.reduce((totalPrice, item) => totalPrice + item.price, 0)
        ).toFixed(2);


        let classes = ['float-cart'];

        if (!!this.state.isOpen) {
            classes.push('float-cart--open');
        }

        if (this.state.redirect) {
            return <Redirect push to="/checkout" />;
        }

        return (
            <div className={classes.join(' ')}>
                {/* If cart open, show close (x) button */}
                {this.state.isOpen && (
                    <div
                        onClick={() => this.closeFloatCart()}
                        className="float-cart__close-btn"
                    >
                        X
                    </div>
                )}

                {/* If cart is closed, show bag with quantity of product and open cart action */}
                {!this.state.isOpen && (
                    <span
                        onClick={() => this.openFloatCart()}
                        className="bag bag--float-cart-closed"
                    >
                        <span className="bag__quantity">{this.props.cartItems.length + this.props.cartGISData.length + this.props.cartSTPData.length}</span>
                    </span>
                )}

                <div className="float-cart__content">
                    <div className="float-cart__header">
                        <span className="bag">
                            <span className="bag__quantity"> {this.props.cartItems.length + this.props.cartGISData.length + this.props.cartSTPData.length}</span>
                        </span>
                        <span className="header-title">Cart</span>
                    </div>
                    <div className="float-cart__shelf-container">
                        {products.length > 0 && (
                            <div className="card">
                                <div className="card-body div-background-color">
                                    <h5 className="category-title card-title">User Defined Region</h5>
                                    {products}
                                </div>
                            </div>
                        )}

                        {gisData.length > 0 && (
                            <div className="card">
                                <div className="card-body div-background-color">
                                    <h5 className="category-title card-title">Downloadable GIS Data</h5>
                                    {gisData}
                                </div>
                            </div>
                        )}


                        {stpData.length > 0 && (
                            <div className="card">
                                <div className="card-body div-background-color">
                                    <h5 className="category-title card-title">STP Data</h5>
                                    {stpData}
                                </div>
                            </div>
                        )}
                        {(products.length === 0 && gisData.length === 0 && stpData.length === 0) && (
                            <p className="shelf-empty">
                                Add some products in the cart. <br />
                            </p>
                        )}
                    </div>
                    <div className="float-cart__footer">
                        <div className="sub">Grand Total (Service Tax 8%)</div>
                        <div className="sub-price">
                            <p className="sub-price__val">RM {priceTotal.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                        </div>
                        <div onClick={() => this.proceedToCheckout()} className={(products.length > 0 || gisData.length > 0 || stpData.length > 0) ? "buy-btn" : "buy-btn disabled"}>Checkout</div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Cart;


// WEBPACK FOOTER //
// ./src/components/FloatCart/Cart.js